import { GetServerSideProps, NextPage } from "next";

import { SignIn } from "src/components/routes/SignIn/SignIn";
import NoAuthWrapper from "src/components/no-authentication";
import { CountryCodeSupported } from "src/common/country";
import { countryCodeFromRequestHeaders } from "src/common/api/utils";

interface InitialProps {
  userCountry: CountryCodeSupported;
}

const SignInRoot: NextPage<InitialProps> = ({ userCountry }) => (
  <NoAuthWrapper userCountry={userCountry}>
    <SignIn defaultCountryCode={userCountry} />
  </NoAuthWrapper>
);

export const getServerSideProps: GetServerSideProps<InitialProps> = async ({
  req,
}) => {
  const userCountry = countryCodeFromRequestHeaders(
    req.headers
  ) as CountryCodeSupported;

  return {
    props: {
      userCountry,
    },
  };
};

export default SignInRoot;
